import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PeticaoAreasListaComponent } from 'app/pages/peticao/peticao-areas/peticao-areas-lista/peticao-areas-lista.component';
import { PeticaoAreasFormComponent } from 'app/pages/peticao/peticao-areas/peticao-areas-form/peticao-areas-form.component';
import { PeticaoTeseListaComponent } from 'app/pages/peticao/peticao-tese/peticao-tese-lista/peticao-tese-lista.component';
import { PeticaoTeseFormComponent } from 'app/pages/peticao/peticao-tese/peticao-tese-form/peticao-tese-form.component';
import { PeticaoListaComponent } from 'app/pages/peticao/peticao/peticao-lista/peticao-lista.component';
import { PeticaoFormComponent } from '@app/pages/peticao/peticao/peticao-form/peticao-form.component';

import { AuthGuard } from '@app/guards/auth.guard';


const peticaoRoutes: Routes = [

  { path: 'lista', component: PeticaoListaComponent, canActivate: [AuthGuard] },
  { path: 'novo', component: PeticaoFormComponent, canActivate: [AuthGuard] },
  { path: 'lista/editar/:id', component: PeticaoFormComponent, canActivate: [AuthGuard] },

  // { path: 'areas', component: PeticaoAreasListaComponent, canActivate: [AuthGuard] },
  // { path: 'areas/novo', component: PeticaoAreasFormComponent, canActivate: [AuthGuard] },
  // { path: 'areas/editar/:id', component: PeticaoAreasFormComponent, canActivate: [AuthGuard] },

  { path: 'teses', component: PeticaoTeseListaComponent, canActivate: [AuthGuard] },
  { path: 'teses/novo', component: PeticaoTeseFormComponent, canActivate: [AuthGuard] },
  { path: 'teses/editar/:id', component: PeticaoTeseFormComponent, canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forChild(peticaoRoutes)],
  exports: [RouterModule]
})
export class PeticaoRoutingModule { }
